/**
 * useFloatingMenuTheme - 플로팅 메뉴 테마 훅
 * 
 * 페이지별로 적절한 테마를 반환합니다.
 * FloatingUserMenu와 QuickInfoContainer에서 재사용 가능
 */
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { getThemeForPage } from '../styles/themes';

export default function useFloatingMenuTheme() {
    const location = useLocation();

    const currentTheme = useMemo(() => {
        const baseTheme = getThemeForPage(location.pathname);
        const isCalendarRelatedPage =
            location.pathname === '/calendar' ||
            location.pathname === '/public-calendar';

        if (isCalendarRelatedPage) {
            return {
                ...baseTheme,
                activeColor: '#00cc00',
                inactiveColor: '#333333',
                backgroundColor: '#fffdf8',
                borderColor: '#666666',
                inactiveBorderColor: '#666666'
            };
        }

        return baseTheme;
    }, [location.pathname]);

    return currentTheme;
}
